import { IOperator } from 'api/types/_operator';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Row } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import TableContainer from "../../../components/Common/TableContainer";
import TriggerEventForm from './TriggerEventForm';
import { formatDateStringToKorea, formatNumberWithCommas } from 'helpers/format';
import CopyWrapper from 'components/Common/CopyWrapper';
import { deleteReferralRule, putReferralRule } from 'store/referral-rule/thunk';
import DropdownStatusNew from 'components/Common/DropdownStatusNew';
import { COLOR_REFERRAL_RULE_ROLE, COLOR_STATUS_POST, getPlatFormImage, LIST_REFERRAL_RULE_ROLE_OPTION, STATUS_ACTIVE_DISABLE_OPTION, STATUS_POST_OPTION } from 'helpers/constans';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import moment from 'moment';
import DropdownOptionNew from 'components/Common/DropdownOptionNew';
import { Option } from 'api/types/_public';
import { deleteReferralTriggerEvent, getReferralTriggerEvents, putReferralTriggerEvent } from 'store/referral-trigger-event/thunk';


registerLocale('en', en);
registerLocale('ko', ko);

const ReferralTriggerEvents = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const LEVELS = Array.from({ length: 10 }, (_, index) => ({
    value: index + 1,
    label: `${t('Level')} ${index + 1}`
  }));

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    name: withDefault(StringParam, ""),
    code: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, ''),
  });

  const [nameSearch, setNameSearch] = useState<string>(query?.name || "");
  const [codeSearch, setCodeSearch] = useState<string>(query?.code || "");

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    STATUS_ACTIVE_DISABLE_OPTION?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [triggerEventEdit, setTriggerEvent] = useState<any>(null);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<IOperator | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.TriggerEvent;

  const TriggerEventProperties = createSelector(
    selectLayoutState,
    (state) => ({
      triggerEvents: state.triggerEvents,
      isTriggerEventSuccess: state.isTriggerEventSuccess,
      isTriggerEventLoading: state.isTriggerEventLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { triggerEvents, error, isTriggerEventLoading } = useSelector(TriggerEventProperties);


  useEffect(() => {
    dispatch(getReferralTriggerEvents(query));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      name: nameSearch,
      code: codeSearch,
      status: statusSearch,
      start_date: startDate
        ? moment(new Date(startDate)).format("Y-MM-DD")
        : "",
      end_date: endDate
        ? moment(new Date(endDate)).endOf("day").format("Y-MM-DD")
        : "",
      page: 1,
      time_request: + new Date()
    });
  };

  const resetData = () => {
    setQuery({
      name: '',
      code: '',
      start_date: "",
      end_date: "",
      sort_by: '',
      time_request: + new Date(),
      page: 1,
    }, "push")
    setNameSearch((_prev) => "");
    setCodeSearch((_prev) => "");
    setStatusSearch("");
    setDateSearch([null, null]);
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setTriggerEvent(null);
    setIsOpen((_prev) => false)
  }

  const triggerRefresh = () => {
    onCloseClick();
    dispatch(getReferralTriggerEvents(query));
  }
  //End::Update User

  // Begin::Delete
  const handleConfirmDelete = (item: IOperator) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!(initialValuesDefault?.id)) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteReferralTriggerEvent(initialValuesDefault?.id);
      if (response?.code === 200) {
        dispatch(getReferralTriggerEvents(query));
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 40,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper contentCopy={item?.id || ''} style={{ display: 'inline-flex', minWidth: '20px' }}>
              <div>
                {triggerEvents?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t('Status'),
        accessor: "status",
        filterable: false,
        sortable: false,
        thClass: 'text-center',
        thWidth: 60,
        Cell: (cell: any) => {
          const value: any = cell?.row?.original;
          const active = value?.status;
          return (
            <div className="text-center form-check form-switch form-switch-sm" dir="ltr" style={{ minWidth: '40px' }}>
              <input type="checkbox" className="form-check-input" name="is_active" id="customSwitchsizelg" checked={Boolean(active)}
                onChange={(event: any) => {
                  if (isHavePermissionRole(ROLES_FOR_APP.OPERATOR_UPDATE, userPermissions)) {
                    handleChangeStatusItem(value, event.target.checked)
                  }
                }}
              />
            </div>
          );
        }
      },
      {
        Header: t('Code'),
        accessor: "code",
        thWidth: 200,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const code = cell?.value;
          return code ? (<CopyWrapper contentCopy={code || ''} style={{ minWidth: '120px' }}>
              {code}
          </CopyWrapper>) : '-'
        },
      },
      {
        Header: t('Name'),
        accessor: "name",
        thWidth: 200,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const name = cell?.value;
          return name ? (<CopyWrapper contentCopy={name || ''} style={{ minWidth: '120px' }}>
              {name}
          </CopyWrapper>) : '-'
        },
      },
      {
        Header: t('Valid Within Hours'),
        accessor: "valid_within_hours",
        thWidth: 100,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const hours = cell?.value;
          return hours ? (<>
            <div style={{ minWidth: '100px' }}>
              <div>{ hours + ` ${t('hours')}` }</div>
            </div>
          </>) : "-"
        },
      },
      {
        Header: t('Created at'),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 110,
        thClass: 'text-end',
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value || '');
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated at'),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 110,
        thClass: 'text-end',
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value || '');
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Action'),
        thClass: 'text-center',
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '70px' }}>
              {isHavePermissionRole(ROLES_FOR_APP.OPERATOR_UPDATE, userPermissions) && (
                <TooltipCustom
                  title={t('Button Update Reward Distribution')}
                  id={`update-us-${item?.id}`}
                >
                  <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                    onClick={(e) => { 
                      setIsOpen(true);
                      setTriggerEvent(item)
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom"></i>
                  </Link>
                </TooltipCustom>
              )}
              {isHavePermissionRole(ROLES_FOR_APP.OPERATOR_DELETE, userPermissions) && (
                <TooltipCustom
                  title={t('Button Delete Reward Distribution')}
                  id={`detail-cp-${item?.id}`}
                >
                    <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                    >
                      <i className="ri-delete-bin-3-fill align-bottom"></i>
                    </Link>
                </TooltipCustom>
              )}
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, query, userPermissions, triggerEvents?.pagination?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeStatusItem = async (item: any, status: boolean) => {
    try {
      const { code, name, valid_within_hours } = structuredClone(item);
      const data = {
        code,
        name,
        valid_within_hours,
        status: Number(status),
      };
      const response: any = await putReferralTriggerEvent(item?.id, data);
      if (response?.data) {
        dispatch(getReferralTriggerEvents(query));
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }


  useEffect(() => {
    document.title = `${t('Reward Distribution Settings')} - ${t('Home')} | Baive`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Reward Distribution Settings')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.OPERATOR_LIST, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-5 con-sm-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t('Total')}:</span>
                            <CountUp
                              start={0}
                              end={triggerEvents?.pagination?.total || 0}
                              duration={1}
                              className="text-primary"
                            />
                          </h5>
                        </div>
                      </div>
                      <div className="col-7 con-sm-6 text-end">
                        {isHavePermissionRole(ROLES_FOR_APP.OPERATOR_CREATE, userPermissions) && (<div className="col-sm-auto">
                          <div>
                            <button
                              type="button"
                              className="btn btn-success add-btn"
                              id="create-btn"
                              onClick={() => setIsOpen((_prev) => true)}
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              {t('Button Create Reward Distribution')}
                            </button>
                          </div>
                        </div>)}
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <Row className="g-4 align-items-center mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Code")}
                          isShow={!!codeSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Code")}...`}
                            value={codeSearch}
                            onChange={(e) => setCodeSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Name")}
                          isShow={!!nameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={nameSearch}
                            onChange={(e) => setNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_POST_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={12} md={12} xl={12} xxl={12} className="hstack gap-1 justify-content-center justify-content-sm-end mt-3 mt-md-3">
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 "
                            onClick={searchData}
                            disabled={isTriggerEventLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t('Button Search')}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t('Button Reset')}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={triggerEvents?.items?.length ? triggerEvents?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={triggerEvents?.pagination?.total}
                      customPageCount={Math.ceil(Number(triggerEvents?.pagination?.total) / Number(triggerEvents?.pagination?.limit))}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isTriggerEventLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}</Row>
        </Container>
        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

        {
          isOpen && (
            <TriggerEventForm
                id={String(triggerEventEdit?.id || '')}
                item={triggerEventEdit}
                triggerRefresh={triggerRefresh}
                lstLevel={LEVELS}
                onCloseClick={onCloseClick}
              />
          )
        }

        <ModalConfirm
          header={t('Button Delete Reward Distribution')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />
      </div >
    </React.Fragment >
  );
};

export default ReferralTriggerEvents;